import React from "react";

interface FilterTabsProps {
  selectedStatus: string;
  onStatusChange: (status: string) => void;
  loading?: boolean;
}

export const FilterTabs: React.FC<FilterTabsProps> = ({
  selectedStatus,
  onStatusChange,
  loading = false,
}) => {
  const filterTabs = [
    { key: "all", label: "All" },
    { key: "Hire", label: "Hire" },
    { key: "Consider", label: "Consider" },
    { key: "Do Not Hire", label: "Do Not Hire" },
  ];

  return (
    <div className="border-b border-gray-200">
      <nav className="flex -mb-px">
        {filterTabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onStatusChange(tab.key)}
            disabled={loading}
            className={`
              py-3 px-6 font-medium text-sm border-b-2 transition-colors duration-200
              ${
                selectedStatus === tab.key
                  ? "border-[#0B60D6] text-[#0B60D6]"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }
              ${loading ? "opacity-50 cursor-not-allowed" : ""}
            `}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
};
